export default __webpack_public_path__ + "static/media/ipermitIcon.146c1416.svg";